import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { PersonalInfo } from "@/components/PersonalInfo";
import { Expertise } from "@/components/Expertise";
import { Skills } from "@/components/Skills";
import { Experience } from "@/components/Experience";
import { Education } from "@/components/Education";
import { Achievements } from "@/components/Achievements";
import { Interests } from "@/components/Interests";
import { Blogs } from "@/components/Blogs";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <About />
      <PersonalInfo />
      <Expertise />
      <Skills />
      <Experience />
      <Education />
      <Achievements />
      <Interests />
      <Blogs />
      <Testimonials />
      <Contact />
    </main>
  );
}
